export default "__VITE_ASSET__MHZLprxe__"